import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';

import {Topbar} from './components';
import {Box} from '@mui/material';

const useStyles = makeStyles()(theme => {
   return {
      root: {
         paddingTop: '64px',
         height: '100%'
      },
      content: {
         height: '100%'
      }
   };
});

const LoginLayout = props => {
   const {children} = props;
   const {classes} = useStyles();
   return (
      <Box className={classes.root}>
         <Box component="main" className={classes.root}>
            {children}
         </Box>
      </Box>
   );
};

LoginLayout.propTypes = {
   children: PropTypes.node,
   className: PropTypes.string
};

export default LoginLayout;
